export default __webpack_public_path__ + "static/Inter-Bold-88fa7ae373b07b41ecce77adbdf16ec2.ttf";